/**
 * Validate the serial number and returns true or false
 * @param {String} serialNumber
 * @returns {Boolean}
 */
export function formValidation(serialNumber) {
  const regex = /^[a-zA-Z0-9]+$/;
  const isValidSerialNumber = Boolean(serialNumber.match(regex));

  return isValidSerialNumber;
}
